<div [formGroup]="getFormGroup()" class="form-group" [hidden]="getHidden()">
    <label class="control-label bs-label th-text-main fw-bold" [class.col-sm-2]="getOneLineControl()">{{getLabelValue()}} <span class="required-span" *ngIf="getRequired()">*</span></label>
    <div [class.col-sm-10]="getOneLineControl()">
        <textarea class="form-control" 
        [rows]="rows ? rows : 6" 
        #el 
        [formControlName]="getModelId()" 
        [name]="getModelId()" 
        [id]="getId()"
        [placeholder]="getPlaceHolder()"
        [maxLength]="getMaxLength()" 
        [required]="getRequired()" 
        [disabled]="getReadOnly()"></textarea>
    </div>
    <small class="help-block text-danger" [class.col-sm-10]="getOneLineControl()"
        [class.pull-right]="getOneLineControl()"
        *ngIf="el.errors?.required && el.touched">{{getRequiredMessage()}}</small>
</div>